import { Head as Helmet } from 'vite-react-ssg';
import { getSiteLastUpdatedDateTimeISO } from '@/constants/siteLastUpdated';

/** Globale freshness-signalen voor crawlers (og:updated_time, article:modified_time). */
export function SiteLastUpdatedHead() {
  const modified = getSiteLastUpdatedDateTimeISO();

  return (
    <Helmet>
      <meta property="og:updated_time" content={modified} />
      <meta property="article:modified_time" content={modified} />
    </Helmet>
  );
}
